module.exports = __webpack_public_path__ + "img/knowlarity.b2bbf90e.png";